import React from 'react';
import PropTypes from 'prop-types';
import { Price } from './price';
import getTranslatedText from '../../../helper/get_translated_text';
import { getTranslationElement } from '../../../helper/getTranslationElement';

const getLabel = onClick =>
    getTranslationElement('pdp-sidebar-all-items-price-mates-rates', {}, { onClick });

export const ProductPriceMatesRates = props => (
    <Price
        name="product-price product-price--mates-rates"
        label={getLabel(props.onMatesRatesLearnMoreClick)}
        price={props.price}
        currencyIsoCode={props.currencyIsoCode}
        overrides={{ decimalDigits: 2 }}
    />
);

ProductPriceMatesRates.propTypes = {
    price: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    onMatesRatesLearnMoreClick: PropTypes.func.isRequired,
};
